const ABOUT_IMG =
  "https://images.unsplash.com/photo-1758519288417-d359ac3c494d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBjb3Jwb3JhdGUlMjBjb25zdWx0aW5nJTIwbWVldGluZ3xlbnwwfHx8fDE3NzY4MjQwMTd8MA&ixlib=rb-4.1.0&q=85";

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-28 md:py-40 bg-[#050914]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        <div className="lg:col-span-5 order-2 lg:order-1">
          <div className="relative reveal">
            <div className="absolute -top-4 -left-4 w-full h-full border border-[#d4af37]/60 pointer-events-none" />
            <img
              src={ABOUT_IMG}
              alt="Corporate consulting meeting"
              className="relative w-full h-[420px] md:h-[560px] object-cover grayscale-[15%]"
              data-testid="about-image"
            />
          </div>
        </div>

        <div className="lg:col-span-7 order-1 lg:order-2">
          <p
            className="text-[11px] font-bold uppercase tracking-[0.32em] text-[#d4af37] mb-6 reveal"
            data-testid="about-overline"
          >
            <span className="gold-rule" /> About the Firm
          </p>
          <h2
            className="font-serif-editorial text-4xl md:text-5xl lg:text-6xl font-light leading-[1.05] text-white reveal"
            data-testid="about-headline"
          >
            A trusted name in
            <span className="italic text-[#d4af37]"> government </span>
            &amp; enterprise consulting.
          </h2>

          <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-8 reveal">
            <p className="text-slate-400 leading-relaxed">
              Headquartered in Richmond, Virginia and supported by offices across six
              national markets, Richmond Holdings Group Inc. is a premier, minority-owned
              consulting firm built to win and execute complex federal and enterprise
              engagements.
            </p>
            <p className="text-slate-400 leading-relaxed">
              Our specialists deliver procurement, agile transformation, facilities
              management, staffing, IT support, and strategic advisory—partnering with
              leadership teams to unlock measurable, mission-critical outcomes.
            </p>
          </div>

          <div className="mt-12 grid grid-cols-3 gap-6 md:gap-10 max-w-2xl reveal">
            {[
              { k: "Richmond", v: "Headquarters" },
              { k: "Nationwide", v: "6 Offices" },
              { k: "Minority-Owned", v: "Certified" },
            ].map((s) => (
              <div key={s.v} className="border-l border-[#d4af37]/40 pl-4">
                <div className="font-serif-editorial text-xl md:text-2xl text-white leading-tight">
                  {s.k}
                </div>
                <div className="mt-1 text-[10px] uppercase tracking-[0.24em] text-slate-500">
                  {s.v}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
